import React, { useEffect, useContext, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { AppSettings } from "./../../config/app-settings.js";
import { useAuth } from "../../contexts/AuthContext";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import LoadingIndicator from "../../components/LoadingIndicator";
import ConfirmationDlg from "../../components/ConfirmationDlg";
import { auth } from "../../api";
function PageReset() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const context = useContext(AppSettings);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const [redirect, setRedirect] = useState(false);
  const [loading, setLoading] = useState(false);
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [password, setPassword] = useState("");
  const [open, setOpen] = React.useState(false);

  //forgot
  const [email2, setEmail2] = useState("");
  const handleForgot = async (e) => {
    //console.log("forgot");
    e.preventDefault();
    //console.log("forgot3", email2);
    if (email2) {
      try {
        //setLoading(true);
        const response = await auth.forgotPassword(email2.toLowerCase());

        if (response.ok) {
          const body = await response.json();

          if (body.success) {
            //toast.success(body.message);
            toast.success("Please check your email");
            setOpen(false);
          } else {
            toast.error("Email not found");
          }
        } else {
          const body = await response.json();

          let message = body.message;

          toast.error(message);
        }
      } catch (e) {
        toast.error(e);
        setLoading(false);
      }

      setLoading(false);
    }
  };
  useEffect(() => {
    context.setAppHeaderNone(true);
    context.setAppSidebarNone(true);
    context.setAppContentClass("p-0");

    return function cleanUp() {
      context.setAppHeaderNone(false);
      context.setAppSidebarNone(false);
      context.setAppContentNone(false);
      context.setAppContentClass("");
    };

    // eslint-disable-next-line
  }, []);

  async function handleSubmit(event) {
    event.preventDefault();
    if (!token) {
      toast.error("Invalid token");
    }
    if (passwordConfirm && password) {
      try {
        setLoading(true);
        if (password !== passwordConfirm) {
          toast.error("Password not match");
          setLoading(false);
          return;
        }
        const response = await auth.resetPassword(token, password);
        setLoading(false);
        if (response.ok) {
          const body = await response.json();

          if (body.success) {
            //toast.success(body.message);
            toast.success("Password Updated");
            setTimeout(function () {
              navigate("/login");
            }, 2000);
          } else {
            toast.error("Something went wrong");
          }
        } else {
          toast.error("Something went wrong");
          // navigate("/machine-health");
        }
      } catch (e) {
        navigate("/machine-health");
        toast.error(e);
        setLoading(false);
      }

      setLoading(false);
    }
  }
  return (
    <div className="login">
      <LoadingIndicator open={loading} />
      <div className="login-content">
        <form onSubmit={handleSubmit}>
          <div className="my-1 text-center">
            <img
              src="/assets/img/logo_white.png"
              alt=""
              className="login-logo"
            />
          </div>
          <div className="text-inverse text-opacity-50 text-center mb-4">
            Please Input Your New Password.
          </div>
          <div className="mb-3">
            <div className="d-flex">
              <label className="form-label">
                New Password <span className="text-danger">*</span>
              </label>
            </div>
            <input
              type="password"
              required={true}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="form-control form-control-lg bg-white bg-opacity-5"
              placeholder=""
            />
          </div>
          <div className="mb-3">
            <div className="d-flex">
              <label className="form-label">
                New Password Confirm <span className="text-danger">*</span>
              </label>
            </div>
            <input
              type="password"
              required={true}
              value={passwordConfirm}
              onChange={(e) => setPasswordConfirm(e.target.value)}
              className="form-control form-control-lg bg-white bg-opacity-5"
              placeholder=""
            />
          </div>
          <div className="mb-3 d-flex justify-content-end">
            <a
              href="/Login"
              className="ms-auto text-inverse text-decoration-none text-opacity-50"
            >
              Login
            </a>
          </div>
          <button
            type="submit"
            disabled={loading}
            className="btn btn-outline-theme btn-lg d-block w-100 fw-500 mb-3"
          >
            Update New Password
          </button>
        </form>
      </div>
    </div>
  );
}

export default PageReset;
